/**
 * Where the API lives, decided at runtime.
 *
 * This was a build-time constant, and that broke things: a same-origin build
 * works on hladom.com (where a Worker route serves /api/*) but 404s on
 * hladom.pages.dev, which has no such route. Baking one answer into the bundle
 * means the bundle is only correct on one host.
 *
 * Deciding by hostname instead means one build works everywhere:
 *
 *   hladom.com          → same origin; the Worker route handles /api/*
 *   localhost / 127.*   → same origin; Vite proxies /api to the local Worker
 *   anything else       → the Worker's own hostname, cross-origin
 *
 * `VITE_API_BASE` still overrides everything, for pointing a local build at a
 * deployed API.
 */

/** The Worker's own hostname — the fallback for preview deploys. */
const WORKER_ORIGIN = 'https://hladom-api.ee-4dd.workers.dev'

const SAME_ORIGIN_HOSTS = new Set([
  'hladom.com',
  'www.hladom.com',
  'localhost',
  '127.0.0.1',
])

export const API_BASE: string = (() => {
  const explicit = import.meta.env.VITE_API_BASE
  if (explicit) return explicit
  if (typeof location === 'undefined') return ''
  return SAME_ORIGIN_HOSTS.has(location.hostname) ? '' : WORKER_ORIGIN
})()
